import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from '../App';
import TimeCheck from '../images/TimeCheck.png'; //Pictures ref = https://undraw.co/search

import { updateStartSubmitAssesmentFlag, getAllQuestions } from '../Service/QuestionService';
import { loadPopup } from '../Utils/LoginUtils';
import { useCountdown } from './Countdown/useCountdown';
import { getUserTimeZone, convertUtcToLocal, convertUtcToLocalTime ,convertUtcToLocalTime24hr,convertUtcToLocaldateTime, convertUtcToLocalDateTime, convertUtcDateToLocalDate} from '../Utils/TimeZoneUtils';
export const ShowWaitingCounter = ({ days, hours, minutes, seconds, endDateTime, isTestExpired }) => {

    return (
        <div className='text-center'>
            {
                days && days > 0 ?
                    <>
                        {days} days left
                    </>
                    : hours && hours > 0 ?
                        <>
                            {hours < 10 ? '0' + hours : hours}:{minutes < 10 ? '0' + minutes : minutes}:{seconds < 10 ? '0' + seconds : seconds} left
                        </>
                        : hours === 0 && minutes && minutes > 0 ?
                            <>
                                00:{minutes < 10 ? '0' + minutes : minutes}:{seconds < 10 ? '0' + seconds : seconds} left
                            </>
                            : hours === 0 && minutes === 0 && seconds && seconds > 0 ?
                                <>
                                    00:00:{seconds < 10 ? '0' + seconds : seconds} left
                                </> :
                                isTestExpired ?
                                    <>TEST EXPIRED</>
                                    :
                                    <>Good to go</>
            }
        </div>
    );
};


export const WaitingRoom = () => {
    const { data, setData } = useContext(Store);
    const navigate = useNavigate();

    const [testExpired, setTestExpired] = useState(false);
    let END_TIME_MS = new Date();
    const userTimeZone = getUserTimeZone();
    console.log("userTimeZone = "+userTimeZone)
    if (data && data.startDateTime) {
        console.log("startDateTime "+data.startDateTime)
        END_TIME_MS = convertUtcToLocal(data.startDateTime, userTimeZone);
    }
    console.log("END_TIME_MS "+END_TIME_MS)
    const [days, hours, minutes, seconds] = useCountdown(END_TIME_MS);
    console.log(`Days ${days}, hours ${hours}, minutes ${minutes}, seconds ${seconds}`);


    const processTest = () => {
        if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
            console.log('Updating start/submit flag');
            updateStartSubmitAssesmentFlag(data.assessmentId, 'STARTED').then(response => {
                console.log('updateStartSubmitAssesmentFlag-STARTED', response);
                console.log("email " + data.email + " seccode " + data.secretCode)
                getAllQuestions(data.email, data.secretCode).then(
                    response => {
                        setData(response.data);
                        navigate('/startTest');
                    })
            }).catch(err => {
                console.log('error catched while updateStartSubmitAssesmentFlag-STARTED', err);
                loadPopup(err.code + "- " + err.response.status);
            })
        } else {
            loadPopup(`Days ${days}, hours ${hours}, minutes ${minutes}, seconds ${seconds}`);
        }
    }
  

    useEffect(() => {
        const isTestExpired = () => {
            const endDateTime=convertUtcToLocal(data.endDateTime, userTimeZone);
            const currdatetime= new Date();
            const bool =currdatetime>endDateTime;
            setTestExpired(bool);

        };

        isTestExpired();
    }, [days, hours, minutes, seconds]);

    window.onbeforeunload = (event) => {
        event.preventDefault();
        return "";
    }

    return (
        <div className="text-muted p-2 mt-3 mb-3 " style={{ display: "flex", justifyContent: "center" }} >
            <label className='p-2 border rounded' style={{
            }}>
                <h1 className='display-5 text-center' style={{ marginTop: "0rem" }}>Waiting Room</h1>
                <img src={TimeCheck} style={{ marginTop: "0rem", height: "19rem", width: "22rem" }} alt='timecheckImage' />
            </label>
            <ul className='list-group ps-2' style={{ width: "20rem" }}>
                <li className="list-group-item">
                    <label className='p-2 border rounded' style={{ width: "100%", minWidth: "100%", backgroundColor: "cadetblue", color: "antiquewhite" }}>
                        <h6 className='text-center mt-2' style={{ fontWeight: "400" }}>
                            {convertUtcToLocaldateTime(new Date())}
                        </h6>
                        <h5 className='text-center mt-1' style={{ fontWeight: "600" }}>
                            <ShowWaitingCounter
                                days={days}
                                hours={hours}
                                minutes={minutes}
                                seconds={seconds}
                                endDateTime={data.endDateTime}
                                isTestExpired={testExpired}
                            />

                        </h5>
                    </label>
                </li>
                <li className="list-group-item"><b>Name:</b> {data && data.candidateName}</li>
                <li className="list-group-item"><b>Email:</b> {data && data.email}</li>
                <li className="list-group-item"><b>Duration:</b> {data && data.duration ? data.duration : 120} {data && <span>Minutes</span>}</li>
                <li className="list-group-item">
                    <b>Test Date:</b> {data && data.startDateTime ? convertUtcDateToLocalDate(data.startDateTime) : `submit Before ${data?.endDateTime.split(' ')[0]}`}
                </li>
                <li className="list-group-item">
                    <b>Start Time: </b>
                    {data && data.startDateTime ? convertUtcToLocalTime(data.startDateTime, userTimeZone) : ` Any Time`}
                </li>

                <li className="list-group-item"><b>End Time: </b>
                    {
                        data && data.startDateTime ?convertUtcToLocalTime(data.endDateTime, userTimeZone): ` +2 Hours After test Start`
                    }
                </li>
                <li className="list-group-item">
                    <div className='mt-2'>
                        <button className='btn'
                            style={testExpired ?
                                { backgroundColor: "cadetblue", color: "antiquewhite", width: "100%", cursor: "not-allowed" } :
                                { backgroundColor: "cadetblue", color: "antiquewhite", width: "100%", cursor: "pointer" }}
                            onClick={() => processTest()}
                            disabled={testExpired || days > 0 || hours > 0 || minutes > 0 || seconds > 0}>
                            Start test
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    )
}
